import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Snackbar from "@material-ui/core/Snackbar"
import { Lightbox } from "react-modal-image"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"

import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"

import FloatingLabelInput from "./FloatingLabelInput"

import Select from "react-select"


const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangePartnerRequest extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  requestpartner_id: "",
                  requestpartner_deactive: "",
                  requestpartner_request: "",
                  requestpartner_reason: "",
                  requestpartner_city: "",
                  requestpartner_check_coworker: "",
                  requestpartner_method: "",
                  requestpartner_filedinsur_favorit: "",
                  requestpartner_reason_select: "",
                  requestpartner_expect: "",
                  requestpartner_detail: "",

                  requestpartner_user_id: "",
                  requestpartner_name: "",
                  requestpartner_family: "",
                  user_mobile: "",
                  requestpartner_tell: "",
                  user_email: "",
                  requestpartner_nationalcode: "",
                  requestpartner_timage: "",
                  requestpartner_file: "",
                  requestpartner_image: "",

                  orderBy: "requestpartner_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  openImageBox: false,
                  marketeFilterMobile: "",
                  marketeFilterId: "",
                  marketeFilterName: "",
            }
      }

      handleChangePartnerRequestReason = (event) => {
            this.setState({ requestpartner_reason: event.target.value })
      }

      andleChangePartnerCheckCoworker = (event) => {
            this.setState({ requestpartner_check_coworker: event.target.value })
      }
      handleChangeRequestPartnerMethod = (event) => {
            this.setState({ requestpartner_method: event.target.value })
      }
      handleChangePartnerActiveFieldInsurFavorit = (event) => {
            this.setState({ requestpartner_filedinsur_favorit: event.target.value })
      }
      handleChangePartnerActiveReasonSelect = (event) => {
            this.setState({ requestpartner_reason_select: event.target.value })
      }
      handleChangePartnerActiveExpect = (event) => {
            this.setState({ requestpartner_expect: event.target.value })
      }
      handleChangePartnerActiveDetail = (event) => {
            this.setState({ requestpartner_detail: event.target.value })
      }

      handleChangePartnerCheckCoworker = (event) => {
            this.setState({ requestpartner_check_coworker: event.target.value })
      }

      handleChangePartnerCity = (event) => {
            this.setState({ requestpartner_city: event.target.value })
      }
      handleChangeCarFilterMobile = (event) => {
            this.setState({ marketeFilterMobile: event.target.value }, () => {
                  this.filterFieldCompany()
            })
      }

      handleChangeCarFilterId = (event) => {
            this.setState({ marketeFilterId: event.target.value }, () => {
                  this.filterFieldCompany()
            })
      }
      handleChangeCarFilterName = (event) => {
            this.setState({ marketeFilterName: event.target.value }, () => {
                  this.filterFieldCompany()
            })
      }



      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      newReuest = () => {
            this.setState(
                {
                      requestpartner_id: "",
                      requestpartner_deactive: "",
                      requestpartner_request: "",
                      requestpartner_reason: "",
                      requestpartner_city: "",
                      requestpartner_check_coworker: "",
                      requestpartner_method: "",
                      requestpartner_filedinsur_favorit: "",
                      requestpartner_reason_select: "",
                      requestpartner_expect: "",
                      requestpartner_detail: "",

                      requestpartner_user_id: "",
                      requestpartner_name: "",
                      requestpartner_family: "",
                      requestpartner_tell: "",
                      city_name: "",
                      state_name: "",
                      requestpartner_address: "",
                      requestpartner_educationlevel: "",
                      requestpartner_fieldofstudy: "",
                      requestpartner_lastjob: "",
                      requestpartner_type: "",
                      requestpartner_insurancehistory: "",
                      user_mobile: "",
                      user_email: "",
                      requestpartner_nationalcode: "",
                      requestpartner_timage: "",
                      requestpartner_file: "",
                      requestpartner_image: "",
                },
                () => {}
            )
      }

      handleSelectRows = (row2) => {
            this.setState(
                {
                      requestpartner_id: row2.requestpartner_id,
                      requestpartner_deactive: row2.requestpartner_deactive,
                      requestpartner_request: row2.requestpartner_request,
                      requestpartner_reason: row2.requestpartner_reason,
                      requestpartner_city: row2.requestpartner_city,
                      requestpartner_check_coworker: row2.requestpartner_check_coworker,
                      requestpartner_method: row2.requestpartner_method,
                      requestpartner_filedinsur_favorit: row2.requestpartner_filedinsur_favorit,
                      requestpartner_reason_select: row2.requestpartner_reason_select,
                      requestpartner_expect: row2.requestpartner_expect,
                      requestpartner_detail: row2.requestpartner_detail,
                      city_name: row2.city_name,
                      state_name: row2.state_name,
                      requestpartner_address: row2.requestpartner_address,
                      requestpartner_educationlevel: row2.requestpartner_educationlevel,
                      requestpartner_fieldofstudy: row2.requestpartner_fieldofstudy,
                      requestpartner_lastjob: row2.requestpartner_lastjob,
                      requestpartner_insurancehistory: row2.requestpartner_insurancehistory,
                      requestpartner_type: row2.requestpartner_type,

                      requestpartner_user_id: row2.requestpartner_user_id,
                      requestpartner_name: row2.requestpartner_name,
                      requestpartner_family: row2.requestpartner_family,
                      user_mobile: row2.user_mobile,
                      requestpartner_tell: row2.requestpartner_tell,
                      user_email: row2.user_email,
                      requestpartner_nationalcode: row2.requestpartner_nationalcode,
                      requestpartner_timage: row2.requestpartner_timage,
                      requestpartner_file: row2.requestpartner_file,
                      requestpartner_image: row2.requestpartner_image,
                },
                () => {}
            )
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getPartnerRequest()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getPartnerRequest() {
            const { rowsPerPage, page } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              console.log("arr is :", arr)
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data, arrCount: arr.cnt }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_list")
            fd.append("requestpartner_active", '1')
            fd.append("limit", rowsPerPage)
            fd.append("offset", page * rowsPerPage)

            xhttp.open("POST", `${constants.BASE_URL}/requestpartner_list`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }


      changePartnerRequest = () => {
            const {
                  requestpartner_id,
                  requestpartner_reason,
                  requestpartner_city,
                  requestpartner_check_coworker,
                  requestpartner_method,
                  requestpartner_filedinsur_favorit,
                  requestpartner_reason_select,
                  requestpartner_expect,
                  requestpartner_detail,
            } = this.state
            if (requestpartner_id != "" ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPartnerRequest()
                                    self.newReuest()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "changerequestmarketer")
                  fd.append("requestpartner_id", requestpartner_id)
                  fd.append("requestpartner_reason", requestpartner_reason)
                  fd.append("requestpartner_check_coworker", requestpartner_check_coworker)
                  fd.append("requestpartner_method", requestpartner_method)
                  fd.append("requestpartner_filedinsur_favorit", requestpartner_filedinsur_favorit)
                  fd.append("requestpartner_reason_select", requestpartner_reason_select)
                  fd.append("requestpartner_expect", requestpartner_expect)
                  fd.append("requestpartner_detail", requestpartner_detail)
                  fd.append("requestpartner_city", requestpartner_city)

                  xhttp.open("POST", `${constants.BASE_URL}/requestpartner_list`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات مقصد  را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changeActivePartnerRequest = (active) => {
            const {
                  requestpartner_id,

            } = this.state
            if (requestpartner_id != "" ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.changePartnerRequest()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "changeactive")
                  fd.append("requestpartner_id", requestpartner_id)
                  fd.append("requestpartner_active", active)


                  xhttp.open("POST", `${constants.BASE_URL}/requestpartner_list`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات مقصد  را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }


      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                i,
                j,
                temp,
                a,
                b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 }, () => {
                  this.getPartnerRequest()
            })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) }, () => {
                  this.getPartnerRequest()
            })
      }

      setImageModel = (image, largimage, desc) => {
            this.setState({
                  urlToLargeImageFile: largimage,
                  urlToHugeImageFile: image,
                  descImageFile: desc,
                  openImageBox: true,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }

      filterFieldCompany = () => {
            const {
                  marketeFilterMobile,
                  marketeFilterId,
                  marketeFilterName,
                  selectedFilterCarMode,
                  selectedFilterCarCompany,
                  selectedFilterCarGroup,
                  requestinfos,
            } = this.state

            var temparray = requestinfos,
                temparray2 = [],
                i,
                namefamily
            for (i = 0; i < temparray.length; i++) {
                  namefamily = temparray[i].requestpartner_name + " " + temparray[i].requestpartner_family
                  if (
                      (marketeFilterMobile === "" || temparray[i].user_mobile.indexOf(marketeFilterMobile) !== -1) &&
                      (marketeFilterId === "" || temparray[i].requestpartner_user_id.indexOf(marketeFilterId) !== -1) &&
                      (marketeFilterName === "" || namefamily.indexOf(marketeFilterName) !== -1)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  marketeFilterMobile,
                  marketeFilterId,
                  marketeFilterName,
                  requestpartner_user_id,
                  requestpartner_name,
                  requestpartner_family,
                  user_mobile,
                  requestpartner_tell,
                  city_name,
                  state_name,
                  requestpartner_address,
                  requestpartner_educationlevel,
                  requestpartner_fieldofstudy,
                  requestpartner_lastjob,
                  requestpartner_type,
                  requestpartner_insurancehistory,
                  user_email,
                  requestpartner_nationalcode,
                  requestpartner_timage,
                  requestpartner_image,
                  requestpartner_file,
                  snackMode,
                  snackstr,
                  showSnack,
                  requestpartner_reason,
                  requestpartner_check_coworker,
                  requestpartner_method,
                  requestpartner_filedinsur_favorit,
                  requestpartner_reason_select,
                  requestpartner_expect,
                  requestpartner_city,
                  requestpartner_detail,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
                  arrCount,
                  urlToHugeImageFile,
                  descImageFile,
                  urlToLargeImageFile,
            } = this.state

            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                      <div className={classes.paperrtl} dir="ltr">
                            <Snackbar
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                onClose={this.handleClickcloseTasckBar}
                                open={showSnack}
                                autoHideDuration={10000}
                            >
                                  <Alert severity={snackMode}>{snackstr}</Alert>
                            </Snackbar>
                            <Grid container spacing={3}>
                                  <Grid item xs={12}>
                                        <Container component="main" maxWidth="lg">
                                              <Paper elevation={4} className={classes.root}>
                                                    <Grid container spacing={3}>
                                                          <Grid item xs={12}></Grid>

                                                          <Grid item xs={3}>
                                                                <Typography align="center" variant="h7">
                                                                      {"آی دی کاربر:   " + requestpartner_user_id}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={5}>
                                                                <Typography align="center" variant="h7">
                                                                      {"نام کاربر :   " + requestpartner_name + " " + requestpartner_family}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={4}>
                                                                <Typography align="center" variant="h7">
                                                                      {" همراه :   " + user_mobile}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={3}>
                                                                <Typography align="center" variant="h7">
                                                                      {" ایمیل :   " + user_email}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={3}>
                                                                <Typography align="center" variant="h7">
                                                                      {" کد ملی :   " + requestpartner_nationalcode}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={3}>
                                                                <Typography align="center" variant="h7">
                                                                      {" شماره تماس:   " + requestpartner_tell}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={3}>
                                                                <Typography align="center" variant="h7">
                                                                      {"  سابقه در صنعت بیمه :   "} {requestpartner_insurancehistory}
                                                                </Typography>
                                                          </Grid>
                                                          <Grid item xs={3}>
                                                                <Typography align="center" variant="h7">
                                                                      {"    سطح تحصیلات :   "} {requestpartner_educationlevel}
                                                                </Typography>
                                                          </Grid>
                                                          <Grid item xs={3}>
                                                                <Typography align="center" variant="h7">
                                                                      {"  رشته :   "} {requestpartner_fieldofstudy}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={3}>
                                                                <Typography align="center" variant="h7">
                                                                      {"  آخرین شغل :   "} {requestpartner_lastjob}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={3}>
                                                                <Typography align="center" variant="h7">
                                                                      {" نوع درخواست همکاری :   "} {requestpartner_type}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={2}>
                                                                <Typography align="center" variant="h7">
                                                                      {" استان: "} {state_name}
                                                                </Typography>
                                                          </Grid>
                                                          <Grid item xs={2}>
                                                                <Typography align="center" variant="h7">
                                                                      {" شهر: "} {city_name}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={8}>
                                                                <Typography align="center" variant="h7">
                                                                      {" آدرس:   "} {requestpartner_address}
                                                                </Typography>
                                                          </Grid>

                                                          <Grid item xs={4}>
                                                                <Typography variant="h7">{"تصویر متقضی: "}</Typography>

                                                                <Avatar
                                                                    variant="rounded"
                                                                    alt="Remy Sharp"
                                                                    src={requestpartner_timage}
                                                                    onClick={() => {
                                                                          this.setImageModel(
                                                                              requestpartner_timage,
                                                                              requestpartner_image,
                                                                              "تصویر متقضی"
                                                                          )
                                                                    }}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={4}>
                                                                <Typography variant="h7">{" رزومه: "}</Typography>
                                                                <a href={requestpartner_file}>دانلود</a>


                                                          </Grid>

                                                          <Grid item xs={4}>

                                                          </Grid>
                                                          <Grid item xs={12}>
                                                                <Divider />
                                                          </Grid>



                                                          <Grid item xs={12}>
                                                                <FloatingLabelInput
                                                                    placeholder="توضیحات بررسی "
                                                                    handleInputt={this.handleChangePartnerRequestReason}
                                                                    value={requestpartner_reason}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                <FloatingLabelInput
                                                                    placeholder=" سابقه در صنعت بیمه "
                                                                    handleInputt={this.handleChangePartnerCheckCoworker}
                                                                    value={requestpartner_check_coworker}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                <FloatingLabelInput
                                                                    placeholder=" نحوه آشنایی "
                                                                    handleInputt={this.handleChangeRequestPartnerMethod}
                                                                    value={requestpartner_method}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={12}>
                                                                <FloatingLabelInput
                                                                    placeholder="  شهر های مورد نظر برای فعالیت "
                                                                    handleInputt={this.handleChangePartnerCity}
                                                                    value={requestpartner_city}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                <FloatingLabelInput
                                                                    placeholder=" رشته های مورد علاقه "
                                                                    handleInputt={this.handleChangePartnerActiveFieldInsurFavorit}
                                                                    value={requestpartner_filedinsur_favorit}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                <FloatingLabelInput
                                                                    placeholder=" دلیل انتخاب رهنمایه بیمه "
                                                                    handleInputt={this.handleChangePartnerActiveReasonSelect}
                                                                    value={requestpartner_reason_select}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                <FloatingLabelInput
                                                                    placeholder=" انتظارات از رهنمایه بیمه "
                                                                    handleInputt={this.handleChangePartnerActiveExpect}
                                                                    value={requestpartner_expect}
                                                                />
                                                          </Grid>
                                                          <Grid item xs={12}>
                                                                <FloatingLabelInput
                                                                    placeholder=" توضیحات "
                                                                    handleInputt={this.handleChangePartnerActiveDetail}
                                                                    value={requestpartner_detail}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={12}>
                                                                <div style={{ width: "100%", textAlign: "right" }}>
                                                                      <Button
                                                                          variant="outlined"
                                                                          color="primary"
                                                                          onClick={(e) => {
                                                                                this.changePartnerRequest()
                                                                          }}
                                                                      >
                                                                            {"ثبت اطلاعات"}
                                                                      </Button>
                                                                </div>
                                                          </Grid>
                                                          <Grid item xs={12}>
                                                                <div style={{ width: "100%", textAlign: "right" }}>

                                                                      <Button
                                                                          variant="outlined"
                                                                          color="primary"
                                                                          onClick={(e) => {
                                                                                this.changeActivePartnerRequest(2)
                                                                          }}
                                                                      >
                                                                            {"رد درخواست"}
                                                                      </Button>
                                                                </div>
                                                          </Grid>
                                                    </Grid>
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper className={classes.root}>
                                                    <Grid container spacing={3}>
                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    placeholder="ای دی کاربر  "
                                                                    handleInputt={this.handleChangeCarFilterId}
                                                                    value={marketeFilterId}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    placeholder="شماره همراه "
                                                                    handleInputt={this.handleChangeCarFilterMobile}
                                                                    value={marketeFilterMobile}
                                                                />
                                                          </Grid>

                                                          <Grid item xs={6}>
                                                                <FloatingLabelInput
                                                                    placeholder="نام کاربر  "
                                                                    handleInputt={this.handleChangeCarFilterName}
                                                                    value={marketeFilterName}
                                                                />
                                                          </Grid>
                                                    </Grid>
                                              </Paper>
                                        </Container>
                                  </Grid>

                                  <Grid item xs={12}>
                                        <Container maxWidth="lg">
                                              <Paper className={classes.root}>
                                                    <TableContainer dir="rtl">
                                                          <Table aria-label="sticky table">
                                                                <TableHead>
                                                                      <TableRow>
                                                                            <TableCell
                                                                                key={"requestpartner_user_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                                sortDirection={orderBy === "requestpartner_user_id" ? order : false}
                                                                            >
                                                                                  {"آیدی کاربر"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "requestpartner_user_id"}
                                                                                      direction={orderBy === "requestpartner_user_id" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("requestpartner_user_id")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"requestpartner_id"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 20 }}
                                                                                sortDirection={orderBy === "requestpartner_id" ? order : false}
                                                                            >
                                                                                  {" شماره درخواست"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "requestpartner_id"}
                                                                                      direction={orderBy === "requestpartner_id" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("requestpartner_id")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell key={"requestpartner_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                  {"نام کاربر  "}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "requestpartner_name"}
                                                                                      direction={orderBy === "requestpartner_name" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("requestpartner_name")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"user_mobile"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {" شماره همراه"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "user_mobile"}
                                                                                      direction={orderBy === "user_mobile" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("user_mobile")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>

                                                                            <TableCell
                                                                                key={"requestpartner_date"}
                                                                                align={"center"}
                                                                                style={{ minWidth: 60 }}
                                                                            >
                                                                                  {"زمان درخواست"}
                                                                                  <TableSortLabel
                                                                                      active={orderBy === "requestpartner_date"}
                                                                                      direction={orderBy === "requestpartner_date" ? order : "asc"}
                                                                                      onClick={(e) => {
                                                                                            this.createSortHandler("requestpartner_date")
                                                                                      }}
                                                                                  ></TableSortLabel>
                                                                            </TableCell>
                                                                      </TableRow>
                                                                </TableHead>

                                                                <TableBody>
                                                                      {agentInfofilter
                                                                          .slice(0, rowsPerPage)
                                                                          .map((row) => {
                                                                                return (
                                                                                    <TableRow
                                                                                        hover
                                                                                        role="checkbox"
                                                                                        tabIndex={-1}
                                                                                        key={row["requestpartner_id"]}
                                                                                        value={row}
                                                                                        onClick={() => {
                                                                                              this.handleSelectRows(row)
                                                                                        }}
                                                                                    >
                                                                                          <TableCell key={"requestpartner_user_id"} align={"center"}>
                                                                                                {row["requestpartner_user_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"requestpartner_id"} align={"center"}>
                                                                                                {row["requestpartner_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"requestpartner_name"} align={"center"}>
                                                                                                {row["requestpartner_name"] + " " + row["requestpartner_family"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_mobile"} align={"center"}>
                                                                                                {row["user_mobile"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                              key={"requestpartner_date"}
                                                                                              align={"center"}
                                                                                          >
                                                                                                {new JDate(
                                                                                                    new Date(
                                                                                                        parseInt(
                                                                                                            Moment(
                                                                                                                row[
                                                                                                                    "requestpartner_date"
                                                                                                                    ],
                                                                                                                "YYYY-M-D HH:mm:ss"
                                                                                                            ).format("x")
                                                                                                        )
                                                                                                    )
                                                                                                ).format("YYYY/MM/DD ") +
                                                                                                "ساعت " +
                                                                                                Moment(
                                                                                                    row["requestpartner_date"],
                                                                                                    "YYYY-M-D HH:mm:ss"
                                                                                                ).format("HH:mm")}
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                                )
                                                                          })}
                                                                </TableBody>
                                                          </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                                                        component="div"
                                                        count={arrCount}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onChangePage={this.handleChangePage}
                                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                    />
                                              </Paper>
                                        </Container>
                                  </Grid>
                            </Grid>

                            {okstatus ? (
                                <Alert severity="success">
                                      <AlertTitle>پیام</AlertTitle>
                                      {errstr}
                                </Alert>
                            ) : null}

                            {this.state.openImageBox && (
                                <Lightbox
                                    medium={urlToLargeImageFile}
                                    large={urlToHugeImageFile}
                                    alt={descImageFile}
                                    onClose={this.closeLightbox}
                                    showRotate={true}
                                    hideZoom={false}
                                />
                            )}
                      </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePartnerRequest)
